import Button from '@mui/material/Button';
import TableCell from '@mui/material/TableCell';

import { RunConfigStatus } from 'src/utils/enumerations';

import { Iconify } from 'src/components/iconify';

const ActionButtonCell: React.FC<{
  runConfigStatus: RunConfigStatus;
  runConfigId: string | null;
  id: string;
  onTryAgain: (intentId: string, runConfigId: string) => void;
  onSummaryClick: (runConfigId: string) => void;
}> = ({ runConfigStatus, runConfigId, id, onTryAgain, onSummaryClick }) => (
  <TableCell>
    {runConfigStatus === RunConfigStatus.Failed ? (
      <Button
        variant="outlined"
        size="small"
        sx={{ minWidth: '102px' }}
        onClick={() => onTryAgain(id, runConfigId || '')}
        endIcon={<Iconify icon="ic:round-refresh" />}
      >
        Try again
      </Button>
    ) : (
      <Button
        variant="outlined"
        size="small"
        aria-label="summary-button"
        data-testid="summary-button"
        disabled={runConfigStatus !== RunConfigStatus.Completed}
        onClick={() => onSummaryClick(runConfigId || '')}
        endIcon={<Iconify icon="eva:arrow-ios-forward-fill" />}
      >
        Summary
      </Button>
    )}
  </TableCell>
);

export default ActionButtonCell;
